module.exports = {
  "country": "AM",
  "artist": "Rosa Linn",
  "song": "Snap",
  "year": "2022",
  "place": "20",
  "spotify": "5hx7w26Zi3zafMgvMTUqF6"
};